/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import * as SelectPrimitive from "@radix-ui/react-select";
import type { ComponentRef } from "react";
import * as React from "react";

import type { ThemeType } from "../../../../../global/emotion";
import { colors, radius, spacing } from "../../../../../global/emotion";
import { CheckmarkIcon } from "../../../_base/icons/Icon/GeneralIcons";

const itemStyle: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  backgroundColor: colors.transparent,
  ":hover": {
    backgroundColor: theme.semanticColors.onOverlayLow,
    color: theme.semanticColors.primary,
  },
  ":focus": {
    backgroundColor: theme.semanticColors.onOverlayLow,
    color: theme.semanticColors.primary,
  },
  ":active": {
    backgroundColor: theme.semanticColors.onOverlayLow,
    color: theme.semanticColors.neutralsMedHigh,
  },
  borderRadius: radius.m,
  color: theme.semanticColors.primary,
  columnGap: spacing.m,
  cursor: "pointer",
  display: "flex",
  outline: "none",
  padding: spacing.m,
});
const checkIconStyle: Interpolation = {
  lineHeight: 0,
  marginLeft: "auto",
};

type SelectItemProps = React.ComponentPropsWithoutRef<
  typeof SelectPrimitive.Item
>;

export const SelectItem = React.forwardRef<
  ComponentRef<typeof SelectPrimitive.Item>,
  SelectItemProps
>(({ children, ...props }, ref) => (
  <SelectPrimitive.Item ref={ref} css={itemStyle} {...props}>
    <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
    <span css={checkIconStyle}>
      <SelectPrimitive.ItemIndicator>
        <CheckmarkIcon.SimpleOn />
      </SelectPrimitive.ItemIndicator>
    </span>
  </SelectPrimitive.Item>
));

SelectItem.displayName = "SelectItem";
